// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700;800&family=Outfit:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cjl {
  --cjl-ink: #0b1f33;
  --cjl-mist: #e8eef4;
  --cjl-felt: #14532d;
  --cjl-felt-deep: #0f3d22;
  --cjl-pingwi: #ffa451;
  --cjl-chalk: #f4f7fa;
  --cjl-line: rgba(11, 31, 51, 0.12);
  --cjl-display: "Barlow Condensed", "Outfit", system-ui, sans-serif;
  --cjl-body: "Outfit", system-ui, sans-serif;

  height: 100dvh;
  height: 100svh;
  max-height: 100dvh;
  max-height: 100svh;
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(120% 80% at 10% -10%, rgba(255, 138, 61, 0.16), transparent 55%),
    radial-gradient(90% 70% at 100% 0%, rgba(20, 83, 45, 0.18), transparent 50%),
    linear-gradient(165deg, var(--cjl-chalk) 0%, var(--cjl-mist) 48%, #dfe8f0 100%);
  color: var(--cjl-ink);
  font-family: var(--cjl-body);
  padding:
    max(0.55rem, env(safe-area-inset-top))
    0.9rem
    max(0.55rem, env(safe-area-inset-bottom));
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.cjl__glow {
  pointer-events: none;
  position: absolute;
  border-radius: 50%;
  filter: blur(48px);
  opacity: 0.45;
}

.cjl__glow--a {
  width: 160px;
  height: 160px;
  top: 8%;
  left: -50px;
  background: rgba(255, 164, 81, 0.32);
}

.cjl__glow--b {
  width: 180px;
  height: 180px;
  bottom: 6%;
  right: -60px;
  background: rgba(20, 83, 45, 0.24);
}

.cjl__chrome {
  position: fixed;
  top: max(0.55rem, env(safe-area-inset-top));
  right: max(0.55rem, env(safe-area-inset-right));
  z-index: 30;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.cjl__lang {
  position: relative;
  top: auto;
  right: auto;
  z-index: 1;
}

.cjl__theme {
  display: inline-flex;
  padding: 3px;
  border-radius: 999px;
  background: rgba(11, 31, 51, 0.06);
  border: 1px solid var(--cjl-line);
  flex-shrink: 0;
}

.cjl__theme-btn {
  width: 32px;
  height: 32px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: rgba(11, 31, 51, 0.5);
  display: grid;
  place-items: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;
}

.cjl__theme-btn.is-active {
  background: #fff;
  color: var(--cjl-felt);
  box-shadow: 0 3px 10px rgba(11, 31, 51, 0.12);
}

.cjl__theme-btn:active {
  transform: scale(0.96);
}

.cjl__stage {
  position: relative;
  z-index: 1;
  width: min(420px, 100%);
  margin: 0 auto;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.65rem;
  padding: 1.75rem 0 2.4rem;
}

.cjl__brand {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
  flex-shrink: 0;
}

.cjl__logo {
  width: 112px;
  height: 112px;
  object-fit: contain;
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(11, 31, 51, 0.12);
  padding: 8px;
  box-sizing: border-box;
}

.cjl__logo--initials {
  display: grid;
  place-items: center;
  font-family: var(--cjl-display);
  font-size: 1.85rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: var(--cjl-felt);
  background: linear-gradient(145deg, #fff, #e8f5ee);
  border: 1px solid rgba(20, 83, 45, 0.18);
  padding: 0;
}

.cjl__title {
  margin: 0;
  font-family: var(--cjl-display);
  font-size: clamp(1.55rem, 6.2vw, 2rem);
  font-weight: 800;
  letter-spacing: 0.01em;
  line-height: 1.08;
  text-wrap: balance;
  max-width: 18ch;
}

.cjl__lead {
  margin: 0;
  max-width: 28rem;
  font-size: 0.86rem;
  line-height: 1.3;
  color: rgba(11, 31, 51, 0.68);
}

.cjl__error {
  margin: 0;
  padding: 0.65rem 0.8rem;
  border-radius: 12px;
  background: rgba(185, 28, 28, 0.08);
  border: 1px solid rgba(185, 28, 28, 0.25);
  color: #991b1b;
  font-size: 0.86rem;
  flex-shrink: 0;
}

.cjl__paths {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  flex: 0 1 auto;
  min-height: 0;
}

.cjl__path {
  appearance: none;
  border: 1px solid var(--cjl-line);
  border-radius: 16px;
  padding: 0.7rem 0.8rem 0.65rem;
  text-align: left;
  cursor: pointer;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  gap: 0.15rem 0.65rem;
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(8px);
  box-shadow: 0 8px 20px rgba(11, 31, 51, 0.07);
  color: inherit;
  font: inherit;
  -webkit-tap-highlight-color: transparent;
}

.cjl__path:focus-visible {
  outline: 2px solid var(--cjl-felt);
  outline-offset: 2px;
}

.cjl__path:disabled {
  opacity: 0.55;
  cursor: wait;
}

.cjl__path:not(:disabled):active {
  transform: scale(0.99);
}

.cjl__path--player {
  border-color: rgba(20, 83, 45, 0.28);
}

.cjl__path--parent {
  border-color: rgba(255, 138, 61, 0.35);
}

.cjl__path-agents {
  grid-row: 1 / span 2;
  align-self: center;
  display: flex;
  align-items: center;
}

.cjl__path-copy {
  display: flex;
  flex-direction: column;
  gap: 0.08rem;
  min-width: 0;
}

.cjl__path-kicker {
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(11, 31, 51, 0.5);
}

.cjl__path-name {
  font-family: var(--cjl-display);
  font-size: 1.28rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  line-height: 1.1;
}

.cjl__path-desc {
  font-size: 0.78rem;
  line-height: 1.3;
  color: rgba(11, 31, 51, 0.68);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.cjl__path-cta {
  grid-column: 2;
  margin-top: 0.25rem;
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 0.32rem 0.7rem;
  border-radius: 999px;
  font-size: 0.76rem;
  font-weight: 700;
  background: var(--cjl-felt);
  color: #f8fafc;
}

.cjl__path--parent .cjl__path-cta {
  background: linear-gradient(120deg, #e85d04, var(--cjl-pingwi));
  color: #1c1917;
}

.cjl__foot {
  margin: 0;
  text-align: center;
  font-size: 0.78rem;
  color: rgba(11, 31, 51, 0.55);
  line-height: 1.35;
  flex-shrink: 0;
}

.cjl__foot-link {
  color: var(--cjl-felt);
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 0.15em;
}

.cjl__foot-link:hover,
.cjl__foot-link:focus-visible {
  color: var(--cjl-felt-deep);
  outline: none;
}

.cjl__powered {
  position: fixed;
  right: max(0.65rem, env(safe-area-inset-right));
  bottom: max(0.45rem, env(safe-area-inset-bottom));
  z-index: 5;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.4rem 0.55rem 0.4rem 0.75rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(11, 31, 51, 0.08);
  box-shadow: 0 4px 14px rgba(11, 31, 51, 0.08);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  pointer-events: none;
}

.cjl__powered-label {
  font-size: 0.72rem;
  font-weight: 650;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(11, 31, 51, 0.5);
  white-space: nowrap;
}

.cjl__powered-logo {
  height: 36px;
  width: auto;
  max-width: 200px;
  object-fit: contain;
  display: block;
}

/* Very short phones */
@media (max-height: 680px) {
  .cjl__logo {
    width: 88px;
    height: 88px;
    border-radius: 18px;
    padding: 6px;
  }

  .cjl__logo--initials {
    font-size: 1.35rem;
  }

  .cjl__powered-logo {
    height: 32px;
    max-width: 180px;
  }

  .cjl__title {
    font-size: clamp(1.35rem, 5.5vw, 1.7rem);
  }

  .cjl__lead {
    font-size: 0.8rem;
  }

  .cjl__path {
    padding: 0.55rem 0.7rem;
  }

  .cjl__path-name {
    font-size: 1.12rem;
  }

  .cjl__path-desc {
    -webkit-line-clamp: 1;
  }

  .cjl__stage {
    gap: 0.45rem;
    padding: 1.5rem 0 2.6rem;
  }
}

@media (min-width: 720px) {
  .cjl__stage {
    width: min(640px, 100%);
    gap: 0.85rem;
  }

  .cjl__logo {
    width: 128px;
    height: 128px;
  }

  .cjl__powered-logo {
    height: 40px;
    max-width: 220px;
  }

  .cjl__paths {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;
  }

  .cjl__path {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto;
    min-height: 0;
    padding: 0.95rem 0.95rem 0.85rem;
  }

  .cjl__path-agents {
    grid-row: auto;
    margin-bottom: 0.2rem;
  }

  .cjl__path-cta {
    grid-column: 1;
    margin-top: 0.45rem;
  }

  .cjl__path-desc {
    -webkit-line-clamp: 3;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cjl__path {
    transition: none;
  }
}

/* —— Dark mode (persists via BrandContext → app_theme_mode) —— */
.cjl--dark {
  --cjl-ink: #e8eef4;
  --cjl-mist: #1a2330;
  --cjl-chalk: #0f1720;
  --cjl-line: rgba(232, 238, 244, 0.14);
  background:
    radial-gradient(120% 80% at 10% -10%, rgba(255, 138, 61, 0.14), transparent 55%),
    radial-gradient(90% 70% at 100% 0%, rgba(34, 197, 94, 0.12), transparent 50%),
    linear-gradient(165deg, #0b1220 0%, #121a26 48%, #0f1720 100%);
  color: var(--cjl-ink);
}

.cjl--dark .cjl__theme {
  background: rgba(255, 255, 255, 0.06);
  border-color: var(--cjl-line);
}

.cjl--dark .cjl__theme-btn {
  color: rgba(232, 238, 244, 0.55);
}

.cjl--dark .cjl__theme-btn.is-active {
  background: rgba(255, 255, 255, 0.12);
  color: #99f6e4;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.28);
}

.cjl--dark .cjl__logo {
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35);
}

.cjl--dark .cjl__logo--initials {
  color: #99f6e4;
  background: linear-gradient(145deg, #1a2e24, #152018);
  border-color: rgba(153, 246, 228, 0.28);
}

.cjl--dark .cjl__lead,
.cjl--dark .cjl__path-kicker,
.cjl--dark .cjl__path-desc,
.cjl--dark .cjl__foot,
.cjl--dark .cjl__powered-label {
  color: rgba(232, 238, 244, 0.68);
}

.cjl--dark .cjl__path {
  background: rgba(22, 32, 45, 0.88);
  border-color: var(--cjl-line);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.28);
  color: var(--cjl-ink);
}

.cjl--dark .cjl__path--player {
  border-color: rgba(52, 211, 153, 0.28);
}

.cjl--dark .cjl__path--parent {
  border-color: rgba(255, 138, 61, 0.4);
}

.cjl--dark .cjl__path:focus-visible {
  outline-color: #2dd4bf;
}

.cjl--dark .cjl__path-cta {
  background: #0f766e;
  color: #f0fdfa;
}

.cjl--dark .cjl__foot-link {
  color: #5eead4;
}

.cjl--dark .cjl__foot-link:hover,
.cjl--dark .cjl__foot-link:focus-visible {
  color: #99f6e4;
}

.cjl--dark .cjl__error {
  background: rgba(248, 113, 113, 0.12);
  border-color: rgba(248, 113, 113, 0.35);
  color: #fecaca;
}

.cjl--dark .cjl__powered {
  background: rgba(22, 32, 45, 0.88);
  border-color: var(--cjl-line);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
}

.cjl--dark .cjl__powered-logo {
  filter: brightness(1.08);
}

.cjl--dark .lang-shortcut--invite .lang-shortcut__btn {
  border-color: var(--cjl-line);
  background: rgba(22, 32, 45, 0.9);
  color: var(--cjl-ink);
}

.cjl--dark .lang-shortcut--invite .lang-shortcut__panel {
  background: rgba(17, 24, 39, 0.96);
  border-color: var(--cjl-line);
  color: var(--cjl-ink);
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/ClubJoinLanding.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,kCAAkC;EAClC,kEAAkE;EAClE,2CAA2C;;EAE3C,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB;;;mFAGiF;EACjF,qBAAqB;EACrB,4BAA4B;EAC5B;;;6CAG2C;EAC3C,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,OAAO;EACP,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,+CAA+C;EAC/C,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,oBAAoB;EACpB,kCAAkC;EAClC,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,yEAAyE;AAC3E;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,kDAAkD;EAClD,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B,oBAAoB;EACpB,qCAAqC;EACrC,0BAA0B;EAC1B,6CAA6C;EAC7C,cAAc;EACd,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,+DAA+D;EAC/D,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;EAEE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,+CAA+C;EAC/C,iDAAiD;EACjD,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;EACtC,oBAAoB;EACpB,qCAAqC;EACrC,wCAAwC;EACxC,6CAA6C;EAC7C,0BAA0B;EAC1B,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,uCAAuC;IACvC,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,qCAAqC;EACrC;;;kEAGgE;EAChE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,qDAAqD;EACrD,uCAAuC;AACzC;;AAEA;;;;;EAKE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;AACvB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700;800&family=Outfit:wght@400;500;600;700&display=swap\");\n\n.cjl {\n  --cjl-ink: #0b1f33;\n  --cjl-mist: #e8eef4;\n  --cjl-felt: #14532d;\n  --cjl-felt-deep: #0f3d22;\n  --cjl-pingwi: #ffa451;\n  --cjl-chalk: #f4f7fa;\n  --cjl-line: rgba(11, 31, 51, 0.12);\n  --cjl-display: \"Barlow Condensed\", \"Outfit\", system-ui, sans-serif;\n  --cjl-body: \"Outfit\", system-ui, sans-serif;\n\n  height: 100dvh;\n  height: 100svh;\n  max-height: 100dvh;\n  max-height: 100svh;\n  position: relative;\n  overflow: hidden;\n  background:\n    radial-gradient(120% 80% at 10% -10%, rgba(255, 138, 61, 0.16), transparent 55%),\n    radial-gradient(90% 70% at 100% 0%, rgba(20, 83, 45, 0.18), transparent 50%),\n    linear-gradient(165deg, var(--cjl-chalk) 0%, var(--cjl-mist) 48%, #dfe8f0 100%);\n  color: var(--cjl-ink);\n  font-family: var(--cjl-body);\n  padding:\n    max(0.55rem, env(safe-area-inset-top))\n    0.9rem\n    max(0.55rem, env(safe-area-inset-bottom));\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n.cjl__glow {\n  pointer-events: none;\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(48px);\n  opacity: 0.45;\n}\n\n.cjl__glow--a {\n  width: 160px;\n  height: 160px;\n  top: 8%;\n  left: -50px;\n  background: rgba(255, 164, 81, 0.32);\n}\n\n.cjl__glow--b {\n  width: 180px;\n  height: 180px;\n  bottom: 6%;\n  right: -60px;\n  background: rgba(20, 83, 45, 0.24);\n}\n\n.cjl__chrome {\n  position: fixed;\n  top: max(0.55rem, env(safe-area-inset-top));\n  right: max(0.55rem, env(safe-area-inset-right));\n  z-index: 30;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.cjl__lang {\n  position: relative;\n  top: auto;\n  right: auto;\n  z-index: 1;\n}\n\n.cjl__theme {\n  display: inline-flex;\n  padding: 3px;\n  border-radius: 999px;\n  background: rgba(11, 31, 51, 0.06);\n  border: 1px solid var(--cjl-line);\n  flex-shrink: 0;\n}\n\n.cjl__theme-btn {\n  width: 32px;\n  height: 32px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 999px;\n  background: transparent;\n  color: rgba(11, 31, 51, 0.5);\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;\n}\n\n.cjl__theme-btn.is-active {\n  background: #fff;\n  color: var(--cjl-felt);\n  box-shadow: 0 3px 10px rgba(11, 31, 51, 0.12);\n}\n\n.cjl__theme-btn:active {\n  transform: scale(0.96);\n}\n\n.cjl__stage {\n  position: relative;\n  z-index: 1;\n  width: min(420px, 100%);\n  margin: 0 auto;\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.65rem;\n  padding: 1.75rem 0 2.4rem;\n}\n\n.cjl__brand {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.3rem;\n  flex-shrink: 0;\n}\n\n.cjl__logo {\n  width: 112px;\n  height: 112px;\n  object-fit: contain;\n  border-radius: 22px;\n  background: #fff;\n  box-shadow: 0 8px 22px rgba(11, 31, 51, 0.12);\n  padding: 8px;\n  box-sizing: border-box;\n}\n\n.cjl__logo--initials {\n  display: grid;\n  place-items: center;\n  font-family: var(--cjl-display);\n  font-size: 1.85rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  color: var(--cjl-felt);\n  background: linear-gradient(145deg, #fff, #e8f5ee);\n  border: 1px solid rgba(20, 83, 45, 0.18);\n  padding: 0;\n}\n\n.cjl__title {\n  margin: 0;\n  font-family: var(--cjl-display);\n  font-size: clamp(1.55rem, 6.2vw, 2rem);\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  line-height: 1.08;\n  text-wrap: balance;\n  max-width: 18ch;\n}\n\n.cjl__lead {\n  margin: 0;\n  max-width: 28rem;\n  font-size: 0.86rem;\n  line-height: 1.3;\n  color: rgba(11, 31, 51, 0.68);\n}\n\n.cjl__error {\n  margin: 0;\n  padding: 0.65rem 0.8rem;\n  border-radius: 12px;\n  background: rgba(185, 28, 28, 0.08);\n  border: 1px solid rgba(185, 28, 28, 0.25);\n  color: #991b1b;\n  font-size: 0.86rem;\n  flex-shrink: 0;\n}\n\n.cjl__paths {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  flex: 0 1 auto;\n  min-height: 0;\n}\n\n.cjl__path {\n  appearance: none;\n  border: 1px solid var(--cjl-line);\n  border-radius: 16px;\n  padding: 0.7rem 0.8rem 0.65rem;\n  text-align: left;\n  cursor: pointer;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-template-rows: auto auto;\n  gap: 0.15rem 0.65rem;\n  background: rgba(255, 255, 255, 0.86);\n  backdrop-filter: blur(8px);\n  box-shadow: 0 8px 20px rgba(11, 31, 51, 0.07);\n  color: inherit;\n  font: inherit;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.cjl__path:focus-visible {\n  outline: 2px solid var(--cjl-felt);\n  outline-offset: 2px;\n}\n\n.cjl__path:disabled {\n  opacity: 0.55;\n  cursor: wait;\n}\n\n.cjl__path:not(:disabled):active {\n  transform: scale(0.99);\n}\n\n.cjl__path--player {\n  border-color: rgba(20, 83, 45, 0.28);\n}\n\n.cjl__path--parent {\n  border-color: rgba(255, 138, 61, 0.35);\n}\n\n.cjl__path-agents {\n  grid-row: 1 / span 2;\n  align-self: center;\n  display: flex;\n  align-items: center;\n}\n\n.cjl__path-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.08rem;\n  min-width: 0;\n}\n\n.cjl__path-kicker {\n  font-size: 0.64rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(11, 31, 51, 0.5);\n}\n\n.cjl__path-name {\n  font-family: var(--cjl-display);\n  font-size: 1.28rem;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  line-height: 1.1;\n}\n\n.cjl__path-desc {\n  font-size: 0.78rem;\n  line-height: 1.3;\n  color: rgba(11, 31, 51, 0.68);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.cjl__path-cta {\n  grid-column: 2;\n  margin-top: 0.25rem;\n  display: inline-flex;\n  align-items: center;\n  width: fit-content;\n  padding: 0.32rem 0.7rem;\n  border-radius: 999px;\n  font-size: 0.76rem;\n  font-weight: 700;\n  background: var(--cjl-felt);\n  color: #f8fafc;\n}\n\n.cjl__path--parent .cjl__path-cta {\n  background: linear-gradient(120deg, #e85d04, var(--cjl-pingwi));\n  color: #1c1917;\n}\n\n.cjl__foot {\n  margin: 0;\n  text-align: center;\n  font-size: 0.78rem;\n  color: rgba(11, 31, 51, 0.55);\n  line-height: 1.35;\n  flex-shrink: 0;\n}\n\n.cjl__foot-link {\n  color: var(--cjl-felt);\n  font-weight: 700;\n  text-decoration: underline;\n  text-underline-offset: 0.15em;\n}\n\n.cjl__foot-link:hover,\n.cjl__foot-link:focus-visible {\n  color: var(--cjl-felt-deep);\n  outline: none;\n}\n\n.cjl__powered {\n  position: fixed;\n  right: max(0.65rem, env(safe-area-inset-right));\n  bottom: max(0.45rem, env(safe-area-inset-bottom));\n  z-index: 5;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.4rem 0.55rem 0.4rem 0.75rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.78);\n  border: 1px solid rgba(11, 31, 51, 0.08);\n  box-shadow: 0 4px 14px rgba(11, 31, 51, 0.08);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  pointer-events: none;\n}\n\n.cjl__powered-label {\n  font-size: 0.72rem;\n  font-weight: 650;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba(11, 31, 51, 0.5);\n  white-space: nowrap;\n}\n\n.cjl__powered-logo {\n  height: 36px;\n  width: auto;\n  max-width: 200px;\n  object-fit: contain;\n  display: block;\n}\n\n/* Very short phones */\n@media (max-height: 680px) {\n  .cjl__logo {\n    width: 88px;\n    height: 88px;\n    border-radius: 18px;\n    padding: 6px;\n  }\n\n  .cjl__logo--initials {\n    font-size: 1.35rem;\n  }\n\n  .cjl__powered-logo {\n    height: 32px;\n    max-width: 180px;\n  }\n\n  .cjl__title {\n    font-size: clamp(1.35rem, 5.5vw, 1.7rem);\n  }\n\n  .cjl__lead {\n    font-size: 0.8rem;\n  }\n\n  .cjl__path {\n    padding: 0.55rem 0.7rem;\n  }\n\n  .cjl__path-name {\n    font-size: 1.12rem;\n  }\n\n  .cjl__path-desc {\n    -webkit-line-clamp: 1;\n  }\n\n  .cjl__stage {\n    gap: 0.45rem;\n    padding: 1.5rem 0 2.6rem;\n  }\n}\n\n@media (min-width: 720px) {\n  .cjl__stage {\n    width: min(640px, 100%);\n    gap: 0.85rem;\n  }\n\n  .cjl__logo {\n    width: 128px;\n    height: 128px;\n  }\n\n  .cjl__powered-logo {\n    height: 40px;\n    max-width: 220px;\n  }\n\n  .cjl__paths {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 0.75rem;\n  }\n\n  .cjl__path {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto auto auto;\n    min-height: 0;\n    padding: 0.95rem 0.95rem 0.85rem;\n  }\n\n  .cjl__path-agents {\n    grid-row: auto;\n    margin-bottom: 0.2rem;\n  }\n\n  .cjl__path-cta {\n    grid-column: 1;\n    margin-top: 0.45rem;\n  }\n\n  .cjl__path-desc {\n    -webkit-line-clamp: 3;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cjl__path {\n    transition: none;\n  }\n}\n\n/* —— Dark mode (persists via BrandContext → app_theme_mode) —— */\n.cjl--dark {\n  --cjl-ink: #e8eef4;\n  --cjl-mist: #1a2330;\n  --cjl-chalk: #0f1720;\n  --cjl-line: rgba(232, 238, 244, 0.14);\n  background:\n    radial-gradient(120% 80% at 10% -10%, rgba(255, 138, 61, 0.14), transparent 55%),\n    radial-gradient(90% 70% at 100% 0%, rgba(34, 197, 94, 0.12), transparent 50%),\n    linear-gradient(165deg, #0b1220 0%, #121a26 48%, #0f1720 100%);\n  color: var(--cjl-ink);\n}\n\n.cjl--dark .cjl__theme {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: var(--cjl-line);\n}\n\n.cjl--dark .cjl__theme-btn {\n  color: rgba(232, 238, 244, 0.55);\n}\n\n.cjl--dark .cjl__theme-btn.is-active {\n  background: rgba(255, 255, 255, 0.12);\n  color: #99f6e4;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.28);\n}\n\n.cjl--dark .cjl__logo {\n  background: rgba(255, 255, 255, 0.94);\n  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35);\n}\n\n.cjl--dark .cjl__logo--initials {\n  color: #99f6e4;\n  background: linear-gradient(145deg, #1a2e24, #152018);\n  border-color: rgba(153, 246, 228, 0.28);\n}\n\n.cjl--dark .cjl__lead,\n.cjl--dark .cjl__path-kicker,\n.cjl--dark .cjl__path-desc,\n.cjl--dark .cjl__foot,\n.cjl--dark .cjl__powered-label {\n  color: rgba(232, 238, 244, 0.68);\n}\n\n.cjl--dark .cjl__path {\n  background: rgba(22, 32, 45, 0.88);\n  border-color: var(--cjl-line);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.28);\n  color: var(--cjl-ink);\n}\n\n.cjl--dark .cjl__path--player {\n  border-color: rgba(52, 211, 153, 0.28);\n}\n\n.cjl--dark .cjl__path--parent {\n  border-color: rgba(255, 138, 61, 0.4);\n}\n\n.cjl--dark .cjl__path:focus-visible {\n  outline-color: #2dd4bf;\n}\n\n.cjl--dark .cjl__path-cta {\n  background: #0f766e;\n  color: #f0fdfa;\n}\n\n.cjl--dark .cjl__foot-link {\n  color: #5eead4;\n}\n\n.cjl--dark .cjl__foot-link:hover,\n.cjl--dark .cjl__foot-link:focus-visible {\n  color: #99f6e4;\n}\n\n.cjl--dark .cjl__error {\n  background: rgba(248, 113, 113, 0.12);\n  border-color: rgba(248, 113, 113, 0.35);\n  color: #fecaca;\n}\n\n.cjl--dark .cjl__powered {\n  background: rgba(22, 32, 45, 0.88);\n  border-color: var(--cjl-line);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);\n}\n\n.cjl--dark .cjl__powered-logo {\n  filter: brightness(1.08);\n}\n\n.cjl--dark .lang-shortcut--invite .lang-shortcut__btn {\n  border-color: var(--cjl-line);\n  background: rgba(22, 32, 45, 0.9);\n  color: var(--cjl-ink);\n}\n\n.cjl--dark .lang-shortcut--invite .lang-shortcut__panel {\n  background: rgba(17, 24, 39, 0.96);\n  border-color: var(--cjl-line);\n  color: var(--cjl-ink);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
